import { render, staticRenderFns } from "./MobileTopSearch.vue?vue&type=template&id=01b68f52"
import script from "./MobileTopSearch.vue?vue&type=script&lang=ts"
export * from "./MobileTopSearch.vue?vue&type=script&lang=ts"
import style0 from "./MobileTopSearch.vue?vue&type=style&index=0&id=01b68f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports